import { apiFetch } from '../../Util';

async function updateSavedCartStatus(savedCartId, cartStatus) {
  const result = await apiFetch.update(
    ['saved_cart'], savedCartId, { cart_status: cartStatus });
  return result.updated;
}

export default updateSavedCartStatus;
